export const TEST_ID = 'dropZone';

export const FILE_INPUT_TEST_ID = 'dropZoneFileInput';
